import { render } from "./BuilderEstimatorHouseSelectorDesktop.vue?vue&type=template&id=4a99c7fa&scoped=true&ts=true&lang=pug"
import script from "./BuilderEstimatorHouseSelectorDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderEstimatorHouseSelectorDesktop.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderEstimatorHouseSelectorDesktop.vue?vue&type=style&index=0&id=4a99c7fa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a99c7fa"]])

export default __exports__